import { Component, OnInit } from '@angular/core';
import { FunderUsersService, UsuarioService, FundersService } from '../../services/service.index';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import swal2 from 'sweetalert2';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-verfunderusers',
  templateUrl: './verfunderusers.component.html',
  styleUrls: ['./funderusers.component.css']
})
export class VerFunderUsersComponent implements OnInit {
  items: any[] = [];
  usuarios: any[] = [];
  fondeadores: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  searchTerm: string = '';
  agregarfunderuser = false;
  fileName = 'FunderUsers.xlsx';

  constructor(
    public _funderUsersService: FunderUsersService,
    public _usuarioService: UsuarioService,
    public _fundersService: FundersService,
    public router: Router
  ) {}

  ngOnInit() {
    swal2.fire({ title: 'Cargando', allowOutsideClick: false });
    swal2.showLoading();

    const obs1 = this._funderUsersService.getFunderUsers().pipe(catchError(err => { console.error(err); return of([]); }));
    const obs2 = this._usuarioService.getUsuarios().pipe(catchError(err => { console.error(err); return of([]); }));
    const obs3 = this._fundersService.getfundersfinancial().pipe(catchError(err => { console.error(err); return of([]); }));

    forkJoin([obs1, obs2, obs3]).subscribe(([funderUsers, usuarios, fondeadores]) => {
      this.items = funderUsers;
      this.usuarios = usuarios;
      this.fondeadores = fondeadores;
      swal2.close();
    });
  }

  getNombreUsuario(userId: number): string {
    const user = this.usuarios.find(u => u.id === userId);
    return user ? user.name : 'ID: ' + userId;
  }

  getNombreFondeador(funderId: number): string {
    const funder = this.fondeadores.find(f => f.id_funder === funderId);
    return funder ? funder.nombre_fondeador : 'ID: ' + funderId;
  }

  pgone() {
    this.currentPage = 1;
  }

  get filteredData(): any[] {
    return this.items.filter(item =>
      (this.getNombreFondeador(item.funder_id).toLowerCase().includes(this.searchTerm.toLowerCase())) ||
      (this.getNombreUsuario(item.user_id).toLowerCase().includes(this.searchTerm.toLowerCase())) ||
      (item.id && item.id.toString().includes(this.searchTerm))
    );
  }

  get dataToShow(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredData.slice(startIndex, startIndex + this.itemsPerPage);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.itemsPerPage);
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) { this.currentPage = page; }
  }

  previousPage(): void {
    if (this.currentPage > 1) { this.currentPage--; }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) { this.currentPage++; }
  }

  agu() {
    this.agregarfunderuser = true;
  }

  cierracrear(event) {
    this.agregarfunderuser = false;
    this.ngOnInit();
  }

  borraFunderUser(item: any) {
    const nombreFondeador = this.getNombreFondeador(item.funder_id);
    const nombreUsuario = this.getNombreUsuario(item.user_id);
    swal2.fire({
      title: 'Desea eliminar la asociación',
      text: nombreFondeador + ' - ' + nombreUsuario + '?',
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
      allowOutsideClick: false
    }).then(resp => {
      if (resp.value) {
        this._funderUsersService.deleteFunderUser(item.id).subscribe(() => {
          swal2.fire({
            title: 'Asociación eliminada',
            text: 'La asociación fue eliminada con éxito',
            icon: 'success',
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false
          }).then(res => {
            if (res.value) { this.ngOnInit(); }
          });
        }, (err) => {
          console.error(err);
          swal2.fire({
            title: 'Ocurrió un error',
            text: '',
            icon: 'error',
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false
          }).then(res => {
            if (res.value) { this.ngOnInit(); }
          });
        });
      }
    });
  }

  exportexcel() {
    const element = document.getElementById('tablafunderusers');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }
}
